<template>
	<div class="container">
		<div class="page page-settings">
			<div class="page-header">
				<div class="row">
					<div class="col-md-9">
						<h1 class="page-title">Slider Wholesale Banner</h1>
						<div>
							Atur slider banner untuk ditampilkan di halaman depan Wholesale Order
						</div>
					</div>

					<div class="col-md-3">
						<div class="page-header-right text-right">
							<button class="btn btn-primary" @click="showCreateForm = true">
								Add Banner
							</button>
						</div>
					</div>
				</div>
			</div>

			<div class="page-content">
				<creation-form
					v-if="showCreateForm"
					form-type="create"
					@on-cancel-create="handleCancelCreate"
					@on-success-submit="handleSuccessSubmit"
				/>

				<draggable
					v-model="banners"
					group="people"
					@start="drag = true"
					@end="onDraggedEnd"
					handle=".drag-item"
				>
					<div
						class="card card-body card-banner-container mb-4"
						v-for="(banner, bannerIndex) in banners"
						:key="bannerIndex"
					>
						<div class="d-flex card-banner-header">
							<button
								class="btn btn-sm btn-plain"
								:class="{ 'drag-item': !isDragDisabled }"
								v-tooltip="'Drag to order'"
								:disabled="isDragDisabled"
							>
								<i class="bi-grip-vertical"></i>
							</button>

							<span class="banner-title align-self-center mr-auto">
								{{ banner.data.title }}
							</span>

							<button
								class="btn btn-sm btn-plain"
								v-tooltip="'Edit this banner'"
								data-toggle="collapse"
								:data-target="`#section${banner._id}`"
								aria-expanded="false"
								:aria-controls="`section${banner._id}`"
								@click="handleShowEditForm(banner._id, true)"
							>
								<i class="bi-pencil"></i>
							</button>

							<button
								class="btn btn-sm btn-plain"
								v-tooltip="'Remove this banner'"
								@click="showRemoveModal(banner._id)"
							>
								<i class="bi-x-lg"></i>
							</button>

							<button
								class="btn btn-sm btn-plain drag-item"
								v-tooltip="'Click to expand'"
								data-toggle="collapse"
								:data-target="`#section${banner._id}`"
								aria-expanded="false"
								:aria-controls="`section${banner._id}`"
								@click="handleShowEditForm(null, false)"
							>
								<i class="bi-chevron-down"></i>
							</button>
						</div>

						<div class="collapse" ref="collapseRef" :id="`section${banner._id}`">
							<creation-form
								v-if="showEditForm && selectedBannerId === banner._id"
								form-type="edit"
								:selected-id="banner._id"
								:banner="banner.data"
								@on-cancel-edit="handleCancelEdit"
								@on-success-submit="handleSuccessSubmit"
							/>

							<div v-else class="card-body">
								<div>
									<label>Banner Promosi Desktop</label>
									<div class="text-center my-2">
										<img
											class="img-fluid rounded"
											:src="banner.data.image"
											alt=""
										/>
									</div>
								</div>
								<div v-if="banner.data.image_mobile">
									<label>Banner Promosi Mobile</label>
									<div class="text-center my-2">
										<img
											class="img-fluid rounded"
											:src="banner.data.image_mobile"
											alt=""
										/>
									</div>
								</div>
								<strong>Link to : {{ banner.data.url }}</strong>
							</div>
						</div>
					</div>
				</draggable>
			</div>
		</div>

		<notifications group="admin-sliders" position="bottom right" />

		<modal
			v-if="isConfirmDelete"
			class="table-change-status-modal"
			size="medium"
			@close="isConfirmDelete = false"
		>
			<div slot="header">
				<h3>Confirm Status</h3>
			</div>
			<div slot="body">
				<div class="text-left">Are you sure want to remove this banner ?</div>
			</div>
			<div slot="footer">
				<button type="button" class="btn btn-light" @click="isConfirmDelete = false">
					{{ $t('Close') }}
				</button>
				<button
					type="button"
					class="btn btn-danger"
					@click="removeBanner(selectedBannerId)"
				>
					Remove
				</button>
			</div>
		</modal>
	</div>
</template>

<script>
import draggable from 'vuedraggable';
import homepageApi from '@/api/homepage';
import Modal from '@/components/Modal.vue';
import CreationForm from '@/components/admin/slider-wholesale/CreationForm.vue';
import { getAxiosErrorMessage } from '@/lib/helper';
import { getWholesaleBannerList } from '@/api/admin';

export default {
	components: {
		draggable,
		Modal,
		CreationForm,
	},
	data() {
		return {
			showCreateForm: false,
			isFetching: false,
			banners: [],
			limit: 20,
			page: 1,
			sort_by: 'data.sort',
			sort: 'asc',
			selectedBannerId: null,
			isConfirmDelete: false,
			drag: false,
			showEditForm: false,
			isDragDisabled: false,
			activeCollapseElements: [],
		};
	},
	watch: {
		activeCollapseElements: {
			handler(newVal) {
				if (newVal.length > 0) {
					this.isDragDisabled = true;
				} else {
					this.isDragDisabled = false;
				}
			},
		},
	},
	methods: {
		onDraggedEnd() {
			this.drag = false;
			const params = {
				banners: JSON.stringify(this.banners),
			};

			const callback = () => {
				this.fetchBanners();
			};
			const errorCallback = () => {
				this.$notify({
					group: 'admin-sliders',
					title: 'Banner Wholesale',
					text: 'Failed to Change Order',
					type: 'error',
				});
			};

			homepageApi.changeOrderBanner(params, callback, errorCallback);
		},
		fetchBanners() {
			this.isFetching = true;

			const params = {
				limit: this.limit,
				sort_by: this.sort_by,
				sort: this.sort,
				page: this.page,
			};

			const callback = (response) => {
				const banners = response.data;
				this.banners = banners;
				this.isFetching = false;
			};

			const errorCallback = () => {
				this.isFetching = false;
			};

			getWholesaleBannerList(params, callback, errorCallback);
		},
		showRemoveModal(id) {
			this.isConfirmDelete = true;
			this.selectedBannerId = id;
		},
		removeBanner(id) {
			this.isFetching = true;

			const callback = (response) => {
				// const banners = response.data;
				const message = response.message;
				this.$notify({
					group: 'admin-sliders',
					title: 'Delete Banner Wholesale',
					text: message,
					type: 'success',
				});
				this.fetchBanners();
				this.isFetching = false;
				this.isConfirmDelete = false;
			};

			const errorCallback = (e) => {
				const message = getAxiosErrorMessage(e);
				this.$notify({
					group: 'admin-sliders',
					title: 'Delete Banner Wholesale',
					text: message,
					type: 'error',
				});
				this.isFetching = false;
			};

			homepageApi.deleteBanner(id, callback, errorCallback);
		},
		handleCancelCreate(state) {
			this.showCreateForm = state;
		},
		handleSuccessSubmit(formType) {
			if (formType === 'create') {
				this.showCreateForm = false;
			} else if (formType === 'edit') {
				this.showEditForm = false;
			}
			this.handleCancelEdit(false);
			this.fetchBanners();
		},
		handleCancelEdit(state) {
			this.isDragDisabled = false;
			this.showEditForm = state;
			this.selectedBannerId = null;
		},
		handleShowEditForm(id, state) {
			this.showEditForm = state;
			this.selectedBannerId = id;
			this.isDragDisabled = false;

			const collapseElement = this.$refs.collapseRef;
			if (collapseElement) {
				const activeElement = collapseElement.find(
					// eslint-disable-next-line arrow-parens
					(element) => element.id === `section${id}`,
				);
				this.activeCollapseElements = activeElement.id;

				collapseElement.forEach((element, elementIndex) => {
					if (element.id !== activeElement.id) {
						collapseElement[elementIndex].classList.remove('show');
					}
				});
			}
		},
	},
	mounted() {
		this.fetchBanners();
	},
};
</script>

<style scoped lang="scss">
.card-banner-container {
	border: 2px solid #4d4d4d;
	border-radius: 10px;

	.banner-title {
		font-weight: 700;
		font-size: 22px;
		line-height: 120%;
	}

	.drag-item {
		font-weight: 700;
		font-size: 16px;
	}

	label {
		font-weight: 700;
		font-size: 16px;
		line-height: 150%;
	}
}
</style>
